import { Button, IconButton, Select, Stack, Typography } from '@mui/material';
import { styled } from '@mui/system';

export const BorderedStack = styled(Stack)`
  border: 1px solid #025ac580;
  align-items: center;
  width: 232px;
  height: 40px;
  border-radius: 4px;
  justify-content: space-between;
  padding: 0 12px;
`;

export const StyledTypography = styled(Typography)(
  ({ theme }) => `
  color:${theme.palette.primary.main};
  font-size: 15px;
  line-height: 1.73;
  margin: 0 !important;
  font-weight: 500;
 `,
);

export const RightStack = styled(Stack)`
  flex-flow: row-reverse;
`;

export const StyledIconButton = styled(IconButton)`
  padding: 0;
  margin-left: 0 !important;
`;

export const StyledTodayButton = styled(Button)(
  ({ theme }) => `
    color:${theme.palette.primary.main};
  font-size: 15px;
  line-height: 1.73;
  font-weight: 500;
  margin-left: 20px;
  font-family: 'Roboto';
 `,
);

export const RoundedDropdown = styled(Select)(
  ({ theme }) => `
    color:${theme.palette.brand.muted};
    border-radius: 56px;
    width: 220px;
    height: 40px;
    @media (max-width: 1300px) {
      width: auto;
    }
  `,
);

export const StyledStack = styled(Stack)`
  gap: 16px;
  align-items: center;
`;
